import React, { useEffect, useState } from "react";
import {
  MenuItem,
  Select,
  Box,
  Card,
  Container,
  TextField,
  FormControl,
  InputLabel,
  Button,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { useFormik } from "formik";
import { useSnackbar } from "notistack5";
import { Col, Row } from "react-bootstrap";
import { CommonFieldsData } from "./CommonFieldsData";
import { addSupplierApi } from "src/Api/Services/AgentFareRule";
const AddSupplierComp = ({
  fetchData,
  setShow,
  getSupplierList,
  userId,
  gateWayList,
}) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formik = useFormik({
    initialValues: {
      name: "",
      gdsType: null,
      code: "",
      fareType: "",
      airlineMarkup: "",
      fareTypeMarkup: "",
      blockedAutoTicketAirline: "",
      blockedAirport: "",
      airportMarkup: [],
      supStatus: "N",
      extraMarkup: 0,
      gateway: "",
      isHoldActive: false,
    },
    validate: (values) => {
      const errors = {};
      // if (!values.name) {
      //   errors.name = "Name is required";
      // }
      // if (!values.gdsType) {
      //   errors.gdsType = "GDS type is required";
      // }
      // if (!values.code) {
      //   errors.code = "Airline Code is required";
      // }
      return errors;
    },

    onSubmit: (values) => {
      handleSubmitApiCall();
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    isSubmitting,
    handleChange,
    values,
    setFieldValue,
    setSubmitting,
    resetForm,
    handleBlur,
  } = formik;
  const handleSubmitApiCall = async () => {
    try {
      const { data } = await addSupplierApi({
        userid: userId,
        supplierdata: values,
      });
      if (data.statusCode === 200) {
        fetchData();
        resetForm();
        setShow(false);
      }
      enqueueSnackbar(data.message, {
        variant: data.statusCode === 200 ? "success" : "error",
      });
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
    setSubmitting(false);
  };
  useEffect(() => {
    if (values.name) {
      const findSupp = getSupplierList.find(
        (ele) => ele.supplier === values.name,
      );
      setFieldValue("gdsType", findSupp?.gdsType);
      setFieldValue("isLcc", findSupp?.isLcc);
    }
  }, [values.name]);
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Row>
          {CommonFieldsData(values, getSupplierList, gateWayList).map(
            (item, _id) => (
              <Col
                md={12}
                xs={12}
                xl={3}
                key={_id}
                className={item?.class && item?.class}
              >
                {["text", "number"].includes(item.type) && (
                  <TextField
                    type={item.type}
                    placeholder={item.placeholder}
                    size="normal"
                    label={item.label}
                    name={item.name}
                    value={item.value}
                    onChange={handleChange}
                    error={errors[item.name] && touched[item.name]}
                    fullWidth
                    onBlur={handleBlur}
                    required={item.required}
                  />
                )}
                {item.type === "select" && (
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      {item.label}
                    </InputLabel>
                    <Select
                      name={item.name}
                      value={item.value}
                      onChange={handleChange}
                      error={errors[item.name] && touched[item.name]}
                      label={item.label}
                      onBlur={handleBlur}
                      fullWidth
                      required={item.required}
                    >
                      {item.options.map((opt, ind) => (
                        <MenuItem
                          value={
                            item.name === "name"
                              ? opt.supplier
                              : item.name === "gateway"
                              ? opt.gateway
                              : opt.value
                          }
                          key={ind}
                        >
                          {item.name === "name"
                            ? opt.supplier
                            : item.name === "gateway"
                            ? opt.gateway || opt?.name
                            : opt.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {errors[item.name] && touched[item.name] && (
                  <FormHelperText error id="component-error-text">
                    {errors[item.name]}
                  </FormHelperText>
                )}
              </Col>
            ),
          )}
        </Row>
        <div className="text-center mt-4">
          <Button variant="contained" type="submit" disabled={isSubmitting}>
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};

export default AddSupplierComp;
